const State = {
  oftenUseList: []
}

export default State
